var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComplianceExpired(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Compliance-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance--all-states",
    transform: "translate(-773.000000, -411.000000)",
    fill: "#ED3F41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy",
    transform: "translate(734.000000, 404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-3",
    transform: "translate(39.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.771156,4.3712145 L13.139631,4.3712145 L9.514161,0.7712145 L9.514161,4.1140395 C9.488511,4.2425595 9.591336,4.3455645 9.719811,4.3712145 L9.771156,4.3712145 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.11285,9.22635 L8.3934,10.4706 L9.054,12.48795 C9.06345,12.5172 9.06795,12.54735 9.06795,12.57705 C9.06795,12.66705 9.02565,12.7539 8.95005,12.8088 L8.95005,12.80925 C8.9001,12.84525 8.84115,12.8637 8.78175,12.8637 C8.7273,12.8637 8.67195,12.84795 8.6238,12.816 C8.62335,12.81555 8.62245,12.8151 8.622,12.8151 C8.6184,12.8133 8.61525,12.81105 8.61255,12.8088 L6.89715,11.5578 L5.1831,12.8088 C5.13315,12.84525 5.0733,12.8637 5.0139,12.8637 C4.9554,12.8637 4.896,12.8457 4.8456,12.8088 C4.77,12.75435 4.72725,12.66705 4.7277,12.57705 C4.7277,12.55095 4.73085,12.52485 4.7385,12.49875 C4.7394,12.49515 4.7403,12.49155 4.74165,12.48795 L5.4018,10.4706 L3.68235,9.22635 C3.60675,9.171 3.56355,9.08415 3.56355,8.9937 C3.56355,8.96445 3.5685,8.9343 3.57795,8.90505 C3.6162,8.78715 3.72645,8.7075 3.85065,8.7075 L3.85965,8.7075 L5.9724,8.71155 L6.62445,6.6915 C6.66,6.58125 6.7581,6.5043 6.8724,6.4944 L6.8787,6.49395 C6.8805,6.4935 6.8832,6.49305 6.885,6.49305 L6.89715,6.49305 C7.02135,6.49305 7.13205,6.5727 7.1703,6.6915 L7.8228,8.71155 L9.9441,8.70705 L9.945,8.70705 L9.9459,8.70705 C10.0071,8.70705 10.06605,8.7273 10.11375,8.76195 C10.16145,8.7966 10.1988,8.8461 10.2177,8.90505 C10.22715,8.9343 10.23165,8.96445 10.23165,8.9937 C10.23165,9.08415 10.1889,9.171 10.11285,9.22635 L10.11285,9.22635 Z M9.7713,5.40045 C9.0513,5.40045 8.48565,4.8348 8.48565,4.1148 L8.48565,0 L1.5426,0 C0.69435,0 0,0.69435 0,1.54305 L0,16.4574 C0,17.30565 0.69435,18 1.5426,18 L12.3426,18 C13.1913,18 13.88565,17.30565 13.88565,16.4574 L13.88565,5.40045 L9.7713,5.40045 Z",
    id: "Fill-3"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceExpired);
export default __webpack_public_path__ + "static/media/compliance-expired.9b51f67e.svg";
export { ForwardRef as ReactComponent };